import React, { useEffect, useRef } from 'react';

const TopCheckbox = ({ value, projectIDs, handleSelectMultipleProjects }) => {
  const checkRef = useRef();

  useEffect(() => {
    checkRef.current.checked = value === 1;
    checkRef.current.indeterminate = value === -1;
  }, [value]);

  return (
    <input
      type="checkbox"
      ref={checkRef}
      onClick={() => {
        handleSelectMultipleProjects(projectIDs);
      }}
    />
  );
};

export default TopCheckbox;
